module.exports = __webpack_public_path__ + "static/img/3-1.5b7d213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/3-1.png
// module id = 76h0
// module chunks = 10